<form>
  <div class="display-flex mt-10">
    <div class="label-item"><label>File Name:</label></div>
    <div class="form-item">
      <input class="form-control" [(ngModel)]="xmlFileName" name="xmlFileName" type="text" />
    </div>
  </div>

  <div class="display-flex mt-10">
    <div class="label-item"><label>File:</label></div>
    <div class="form-item">
      <input type="file" (change)="onFileSelected($event)" />
    </div>
  </div>

  <div class="display-flex mt-10">
    <button class="btn btn-info" type="button" (click)="upload()" [disabled]="!xmlFile || !xmlFileName || loading">
      Upload
      @if (loading) {
<span><i class="fa fa-spin fa-spinner"></i></span>
}
    </button>
  </div>
</form>
